/**
 * Utility functions for parts cutting and time management
 */

/**
 * Format seconds to MM:SS format
 */
export const formatTime = (seconds) => {
  // Handle NaN, undefined, null, or invalid values
  if (seconds === null || seconds === undefined || isNaN(seconds) || seconds < 0) {
    return '0:00';
  }
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Format time for filename (replace : with -)
 */
export const formatTimeForFilename = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}-${secs.toString().padStart(2, '0')}`;
};

/**
 * Clean filename to remove invalid characters
 */
export const cleanFilename = (filename) => {
  // Remove or replace invalid characters for Windows/Mac/Linux
  const cleaned = filename
    .replace(/[<>:"/\\|?*]/g, '_')  // Replace invalid chars with underscore
    .replace(/\s+/g, '_')           // Replace spaces with underscore
    .replace(/_{2,}/g, '_')         // Replace multiple underscores with single
    .replace(/^_|_$/g, '')          // Remove leading/trailing underscores
    .substring(0, 100);             // Limit length to 100 chars
  
  console.log('🧹 cleanFilename:', { original: filename, cleaned });
  return cleaned;
};

/**
 * Parse time string MM:SS to seconds
 */
export const parseTime = (timeString) => {
  const [mins, secs] = timeString.split(':').map(Number);
  return mins * 60 + secs;
};

/**
 * Format seconds to MM:SS format for input fields
 */
export const formatTimeInput = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Validate time range
 */
export const validateTimeRange = (startTime, endTime, duration) => {
  const start = parseTime(startTime);
  const end = parseTime(endTime);

  if (start >= end) {
    return { valid: false, error: 'End time must be after start time' };
  }

  if (end > duration) {
    return { valid: false, error: 'End time cannot exceed video duration' };
  }

  return { valid: true, start, end };
};

/**
 * Create a new part object
 */
export const createPartObject = (name, startTime, endTime) => {
  const start = parseTime(startTime);
  const end = parseTime(endTime);
  
  return {
    id: Date.now().toString(),
    name,
    startTime: start,
    endTime: end,
    duration: end - start,
    createdAt: new Date().toISOString()
  };
}; 